import { endPromptConversation } from '@/store/gigiChat/Visuals'
import { IShortMessageObject } from '@/types/gigiChat/Chat'
import { IConversation } from '@/types/gigiChat/Conversation'

import ExitPromptLibrary from './ExitPromptLibrary'

const Container = ({ item, isConnected }: { item: IShortMessageObject | IConversation; isConnected: boolean }) => {
    return <ExitPromptLibrary item={item} isConnected={isConnected} endPromptConversation={endPromptConversation} />
}

export default Container
